import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useFetch } from "../lib/useData";
import { PageHero, Section } from "../components/public/PublicLayout";

const HERO = "https://images.unsplash.com/photo-1665003725647-3ae0f01140b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export function News() {
  const { data: news } = useFetch("/public/news");
  const { data: ann } = useFetch("/public/announcements");
  return (
    <div>
      <PageHero title="News & Announcements" subtitle="Latest updates from the temple" image={HERO} />
      <Section>
        {(ann || []).length > 0 && (
          <div className="mb-10 space-y-2" data-testid="announcements-list">
            {ann.map((a) => (
              <div key={a.id} className={`rounded-xl px-5 py-4 border ${a.urgent ? "bg-orange-50 border-orange-300" : "bg-amber-50 border-amber-200"}`}>
                <span className={`text-xs font-bold uppercase mr-2 ${a.urgent ? "text-orange-700" : "text-amber-700"}`}>{a.urgent ? "Important" : "Notice"}</span>
                <span className="text-stone-800 font-medium">{a.title}</span>
              </div>
            ))}
          </div>
        )}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="news-grid">
          {(news || []).map((n) => (
            <Link to={`/happenings/news/${n.slug}`} key={n.id} className="group bg-white rounded-2xl overflow-hidden border border-amber-200/70 hover:shadow-lg transition-all" data-testid={`news-${n.slug}`}>
              <div className="h-44 overflow-hidden"><img src={n.featured_image} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
              <div className="p-5">
                <span className="text-xs font-semibold text-amber-700">{n.category} · {n.date}</span>
                <h3 className="font-display text-lg font-bold text-stone-900 mt-1">{n.title}</h3>
                <p className="text-sm text-stone-600 mt-2 line-clamp-2">{n.short_description}</p>
              </div>
            </Link>
          ))}
        </div>
      </Section>
    </div>
  );
}

export function NewsDetail() {
  const { slug } = useParams();
  const { data: n, loading } = useFetch(`/public/news/${slug}`, [slug]);
  if (loading) return <Section>Loading…</Section>;
  if (!n) return <Section>Article not found.</Section>;
  return (
    <div>
      <PageHero title={n.title} subtitle={`${n.category} · ${n.date}`} image={n.featured_image} />
      <Section className="max-w-3xl">
        <Link to="/happenings/news" className="inline-flex items-center gap-1 text-orange-700 font-semibold mb-6" data-testid="news-back"><ArrowLeft className="w-4 h-4" /> All News</Link>
        <p className="text-lg text-stone-600 leading-relaxed whitespace-pre-line">{n.content}</p>
      </Section>
    </div>
  );
}
